import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Menu from "./Menu";
import Saida from "./saida";
import Estoque from "./estoque";
import Devolucao from "./devolucao";
import Entradas from "./entradas";
import Decisao from "./decisao";
import Restrito from "./arearestrita";
import ProtectedRoute from "./ProtectedRoute";

function Main() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/menu" element={
          <ProtectedRoute><Menu /></ProtectedRoute>
        } />
        <Route path="/saida" element={
          <ProtectedRoute><Saida /></ProtectedRoute>
        } />
        <Route path="/estoque" element={
          <ProtectedRoute><Estoque /></ProtectedRoute>
        } />
        <Route path="/devolucao" element={
          <ProtectedRoute><Devolucao /></ProtectedRoute>
        } />
        <Route path="/entradas" element={
          <ProtectedRoute><Entradas /></ProtectedRoute>
        } />
        <Route path="/decisao" element={
          <ProtectedRoute><Decisao /></ProtectedRoute>
        } />
        <Route path="/arearestrita" element={
          <ProtectedRoute><Restrito /></ProtectedRoute>
        } />

      </Routes>
    </Router>
  );
}

export default Main;
